module.exports = __webpack_public_path__ + "img/lang-ru.ca279e44.svg";